import React from "react";
import Box from "@mui/material/Box";
import OptionCard from "./OptionCard";

const options = [
  {
    value: "mobile",
    label: "Mobile Location",
    description: "A vault, pallet, trailer or container that moves.",
  },
  {
    value: "base",
    label: "Base Location",
    description: "A fixed floor, rack or vault position in the warehouse.",
  },
];

export default function LocationTypeSelection({ locationType, onTypeSelection }) {
  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      {options.map(option => (
        <OptionCard
          key={option.value}
          label={option.label}
          description={option.description}
          selected={locationType === option.value}
          onClick={() => onTypeSelection(option.value)}
        />
      ))}
    </Box>
  );
}
